import React from "react";
import { Provider } from "react-redux";
import createStore from "./store";
import { Route } from "react-router-dom";
import { WrapperProvider } from "create-react-server/wrapper";
import { Helmet } from "react-helmet";

import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Main from "containers/Main/Main";
import Article from "components/Article/Article";
import Rubric from "components/Rubric/Rubric";
import Events from "components/Events/index";
import Library from "containers/Library/Library";
import Project from "containers/Project/Project";
import PaymentSuccess from "components/PaymentSuccess/PaymentSuccess";

module.exports = ({ state, props, req, res }) => {
  if (!state && req) {
    state = {};
  }

  return (
    <Provider store={createStore(state)}>
      <WrapperProvider initialProps={props}>
        <Header />
        <div className="page">
          <Helmet>
            <title>Библиогород</title>
          </Helmet>
          <Route exact path="/" component={Main} />
          {/*на время события библионочь*/}
          <Route path="/biblionight2019" component={Events} />
          <Route path="/specials/:id" component={Events} />
          <Route path="/article/:id" component={Article} />
          <Route path="/articles/:id" component={Rubric} />
          <Route path="/libraries/:id?" component={Library} />
          <Route path="/projects/:id?" component={Project} />
          <Route path="/order/:orderHash?" component={PaymentSuccess} />
          <Footer />
        </div>
      </WrapperProvider>
    </Provider>
  );
};



// WEBPACK FOOTER //
// ./src/app.js